/**
 * Бот ли игрок для правил костей урона: фора новичкам (см.
 * getLowRatingAdvantageDicePenalty) и подкрутка божественного бота, которая
 * против ботов не действует (см. checkIfAnyOpponentIsBot). Ботом считается
 * любой бот партии — неявный бот пула, явный бот рейтинга, бот сетевого лобби,
 * бот локальной партии, кампании, обучения и демо.
 *
 * Признак устойчив к маскам серверного движка ботов, которые меняют isBot в
 * его взгляде на состояние:
 *  - бот под ручным управлением админа выглядит для движка живым (isBot:
 *    false, см. maskControlledBots), но botControlledByUserId остается при
 *    нем — он по-прежнему бот;
 *  - ИИ-игрок на автопилоте выглядит ботом (isBot: true, см.
 *    autopilotPlayers), но он не бот и играет на общих условиях с людьми —
 *    его отличает isAi.
 * Публичные метки isVisibleBot и isLocalBot маски не трогают — они страхуют
 * на случай, если isBot замаскирован.
 * Иначе один и тот же игрок выглядел бы по-разному у разных исполнителей
 * броска (сервер, клиент-делегат хода бота, клиент живого игрока или админа).
 *
 * Нейтральных отрядов в списке игроков нет — по объекту игрока их не узнать
 * (см. checkIfNeutralPlayer).
 *
 * @param {Object} [player] - игрок из состояния партии
 * @returns {boolean}
 */
export const checkIfBotPlayer = (player) => Boolean(player)
  && !player.isAi
  && Boolean(player.isBot || player.botControlledByUserId || player.isVisibleBot || player.isLocalBot);
